'use strict';

angular.module('MW.InsDashboard.TransformSegment', [
    'DashboardChartConfigService',
    'LanguageService',
    'MW.InsDashboard.ChartDataService',
    'MW.Framework.TranslationService',
    'CoreColorService',
    'MW.Framework.GeoService'
])
.factory('TransformSegment', [
    'DashboardChartConfigService',
    'LanguageService',
    'ChartDataService',
    'translationService',
    'CoreColorService',
    'GeoService',
    '$q',
    function (
        DashboardChartConfigService,
        LanguageService,
        ChartDataService,
        translationService,
        CoreColorService,
        GeoService,
        $q) {

    'use strict';
    var transformSegment = {};

    // Formulate the data from the backend service into something we can more easily graph.
    var formulateData = function formulateData(raw_data, chart) {
        var dataSeries = parseRequestData(raw_data),
            currentSeries = dataSeries[0],
            previousSeries = dataSeries[1],
            maxVolume = 0,
            dataSum = 0,
            dataPointPromises,
            dataDeferral = $q.defer();

        dataPointPromises = currentSeries.map(function (series, i) {
            var dataPointDeferral = $q.defer(),
                dataPoint = {
                    volume: series['volume']
                };

            if (series['volume'] > maxVolume) {
                maxVolume = series['volume'];
            }

            dataSum += series['volume'];

            var previousDataVolume  = previousSeries[i] && previousSeries[i]['volume'] || 0;
            if (previousDataVolume == 0) {
                dataPoint.diff = series['volume'] * 100;
            }
            else {
                dataPoint.diff = ((series['volume'] - previousDataVolume) / previousDataVolume) * 100;
            }

            // This isn't the best way to do this - would be nice to have a way to pass in a parameter. Not sure what
            // the most logical way to do it is, though. Something on chart?
            if (typeof series['country'] !== 'undefined') {
                GeoService.convertCountryCodeToName(series['country']).then(function (name) {
                    dataPoint.category = name;
                    dataPointDeferral.resolve(dataPoint);
                });
            }
            else if (typeof series['source'] !== 'undefined') {
                dataPoint.category = series['source'];
                // How can we handle this?
                dataPoint.sourceId = series['sourceId'];
                dataPointDeferral.resolve(dataPoint);
            }
            else if (typeof series['language'] !== 'undefined') {
                dataPoint.category = series['language'];
                dataPointDeferral.resolve(dataPoint);
            }
            else if (typeof series['entity'] !== 'undefined') {
                dataPoint.category = series['entity'];
                dataPointDeferral.resolve(dataPoint);
            }
            else if (typeof series['poster'] !== 'undefined') {
                dataPoint.category = series['poster'];
                dataPoint.id = series['id'];
                dataPointDeferral.resolve(dataPoint);
            }

            return dataPointDeferral.promise;
        });

        $q.all(dataPointPromises).then(function (dataPoints) {
            var dataPoint;

            // Uses the total we calculate in the above view, so we need another loop for it.
            for (var i = 0; i < currentSeries.length; i++) {
                dataPoint = dataPoints[i];

                dataPoint.percent = currentSeries[i]['volume'] * 100 / dataSum;
                dataPoint.y = chart.percent ? dataPoint.percent : dataPoint.volume;

                dataPoints[i] = dataPoint;
            }

            dataDeferral.resolve({
                data: dataPoints,
                categories: dataPoints.map(function projectDataPointCategory (point) {
                    return point.category;
                }),
                maxVolume: maxVolume
            });
        });

        return dataDeferral.promise;
    };

    var getGraphObject = function getGraphObject(chartData) {
        return {
            series: [{
                data: chartData.data
            }],
            xAxis: {
                categories: chartData.categories
            }
        };

    };

    transformSegment.bar = function bar(raw_data, chart) {
        formulateData(raw_data, chart).then(function (chartData) {
            chart.callback(getGraphObject(chartData));
        });
    };

    var parseRequestData = function(dataSeries) {

        var currentSeries, previousSeries;
        // Since we know we only have two requests (the old and new series) we can just check the first one to determine which is which.
        if (dataSeries[0].isPreviousRange) {
            currentSeries = dataSeries[1].datapoints;
            previousSeries = dataSeries[0].datapoints;
        } else {
            currentSeries = dataSeries[0].datapoints;
            previousSeries = dataSeries[1].datapoints;
        }

        return [currentSeries, previousSeries];
    };

    transformSegment.table = function table(raw_data, chart){
        processTable(raw_data, chart).then(function (data) {
            chart.callback(data);
        });
    };

    // Process table data
    var processTable = function processTable(raw_data, chart) {
        var responseDataDeferral = $q.defer(),
            dataSeries = parseRequestData(raw_data),
            data = dataSeries[0],
            percentArray = [],
            totalVolume = 0,
            totalPercent = 0,
            tableDataPromises;

        // Calculating the total of the volume count for summary
        for(var i = 0; i < data.length; i++) {
            totalVolume += data[i].volume;
        }

        // Calculating the percent for datapoint and total percent for summary
        for(var i = 0; i < data.length; i++) {
            percentArray[i] = (data[i].volume == 0 ? 0 : parseFloat((data[i].volume/totalVolume*100).toFixed(1)))
            totalPercent += percentArray[i];
        }

        totalPercent = Math.round(totalPercent);
        totalPercent += '%';

        tableDataPromises = data.map(function projectTableData (dataItem, i) {
            var labelName = '',
                tableItem = {},
                tableItemDeferral = $q.defer();

            tableItem['data'] = [{
                name: raw_data[0].search.name,
                count: dataItem.volume,
                percent: percentArray[i] + '%'
            }];

            switch(chart.insObject) {
                case 'languageHistograms':
                    // labelName = translationService.getLocalizedString(LanguageService.getLanguage(dataItem.language).name);
                    if(dataItem.language == 'zh-Hans') {
                        labelName = translationService.getLocalizedString('Chinese Simplified');
                    } else if (dataItem.language == 'zh-Hant') {
                        labelName = translationService.getLocalizedString('Chinese Traditional');
                    } else {
                        labelName = translationService.getLocalizedString(LanguageService.getLanguage(dataItem.language).name);
                    }

                    tableItem.data[0].filterField = dataItem.language;
                    tableItem.label = labelName;
                    tableItemDeferral.resolve(tableItem);

                    break;
                case 'countryHistograms':
                    tableItem.data[0].filterField = dataItem.country;

                    GeoService.convertCountryCodeToName(dataItem.country).then(function (countryName) {
                        tableItem.label = translationService.getLocalizedString(countryName)
                        tableItemDeferral.resolve(tableItem);
                    });

                    break;
                case 'sourceHistograms':
                    tableItem.data[0].filterField = dataItem.sourceId;
                    tableItem.label = dataItem.source ? dataItem.source : dataItem.sourceId;
                    tableItemDeferral.resolve(tableItem);

                    break;
                case 'entityHistograms':
                    tableItem.data[0].filterField = dataItem.entity;
                    tableItem.label = dataItem.entity;
                    tableItemDeferral.resolve(tableItem);

                    break;
                case 'posterHistograms':
                    tableItem.data[0].filterField = dataItem.poster;
                    tableItem.data[0].id = dataItem.id;
                    tableItem.label = dataItem.poster;
                    tableItemDeferral.resolve(tableItem);
                    break;
            }

            return tableItemDeferral.promise;
        });

        $q.all(tableDataPromises).then(function (tableData) {
            var responseData = {};

            // Sorting table inital view according to first column in ascending order
            // Had to do this because data response from FH comes sorted by data volume
            tableData.sort(function(a, b) {
                if(a.label === b.label) {
                    return 0;
                } else {
                    return (a.label < b.label) ? -1 : 1;
                }
            });

            responseData.table = tableData;
            responseData.countSummary = [totalVolume];
            responseData.percentSummary = [totalPercent];

            responseDataDeferral.resolve(responseData);
        });

        return responseDataDeferral.promise;
    };

    return transformSegment;
}]);
